module.exports = __webpack_public_path__ + "static/media/veiculos.0fd28d66.jpg";